export const GET_BULK_UPLOAD_RECORD = 'GET_BULK_UPLOAD_RECORD';
export const SYNC_BULK_UPLOAD_STATUS = 'SYNC_BULK_UPLOAD_STATUS';
export const GET_BULK_UPLOAD_STAGING_RECORD = 'GET_BULK_UPLOAD_STAGING_RECORD';
export const EXECUTE_BULK_UPLOAD = 'EXECUTE_BULK_UPLOAD';
